/**
 * GSAP Fade In Right Animation
 * 
 * HOW TO USE:
 * Add the class "gsap-fade-in-right" to any HTML element to make it fade in from the right
 * when it enters the viewport.
 * 
 * EXAMPLE:
 * <div class="gsap-fade-in-right">This content will slide in from the right</div>
 * <img class="gsap-fade-in-right" src="image.jpg" alt="This image will animate in">
 * 
 * OPTIONAL MODIFIER:
 * Add "animate-once" class to prevent animation from repeating on scroll:
 * <div class="gsap-fade-in-right animate-once">Animates once only</div>
 * 
 * ANIMATION DETAILS:
 * - Desktop (≥900px): Starts 200px to the right (x: 200), fades from autoAlpha 0 to 1
 * - Mobile (<900px): Starts 25px below (y: 25), fades from autoAlpha 0 to 1
 * - Duration: 1.5s (desktop), 1.25s (mobile)
 * - Easing: circ (circular motion)
 * - Without "animate-once": restarts on scroll up/down
 * - With "animate-once": plays only once
 */

const fadeInRight = document.querySelectorAll(".gsap-fade-in-right");
if (fadeInRight.length) {
  gsap.utils.toArray(".gsap-fade-in-right").forEach((box) => {
    // Check if element has animate-once class
    const animateOnce = box.classList.contains("animate-once");
    
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: box,
        toggleActions: animateOnce ? "play none none none" : "restart none none reset",
      },
    });
    if (window.innerWidth < 900) {
      tl.from(box, {
        duration: 1.25,
        autoAlpha: 0,
        y: 25,
        ease: "circ",
      });
    } else {
      tl.from(box, {
        duration: 1.5,
        autoAlpha: 0,
        x: 200,
        ease: "circ",
      });
    }
  });
}
